/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { setBpMethodOptions } from '../store/options.actions'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { VitalsService } from '../../vitals/services/vitals.service'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* getBpMethods() {
  const serviceId = yield select(getServiceIdSelector)
  const vitalsService = new VitalsService(serviceId)
  try {
    const bpMethodsResponse = yield call([vitalsService, vitalsService.getBpMethods])
    const { entity } = bpMethodsResponse
    yield put(setBpMethodOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getBpMethods() error: ${e}`))
  }
}

export function* getBpMethodsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getBpMethods)
}
